<template>
    <DatePicker 
        :default-value="value"
        :placeholder="placeholder"
        :format="format"
        :type="type"
        :inputClass="inputClass"
        v-model="selectedValue"
        @change="() => (emit('update:value', selectedValue), emit('change', selectedValue))"
        />
</template>

<script setup>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { defineProps, onBeforeMount, ref, defineEmits } from 'vue';

/* ======== PROPS ======= */
const props = defineProps({
    placeholder : {type : String, default : () => 'Select date'},
    value : {type : [String, Date], default : () => ''},
    type : {type : String, default : () => 'date'},
    format : {type : String, default : () => 'MM/DD/YYYY'},
    inputClass : {type : String, default : () => ''},
})

/* ========= EMITS ====== */
const emit = defineEmits(['change', 'update:value'])

/* ========= STATES ========== */
const selectedValue = ref('')


/* ========= ONLOAD ========= */
onBeforeMount(() => {
    selectedValue.value = props.type == 'date' ? new Date(props.value) : new Date(`1/1/2025 ${props.value}`)
})

</script>
